angular.module('login')
.controller('LoginController', ['$scope', '$stateParams', 'Auth', 'User', '$location', 'Login', 'redirect', 'Logger', 'Notification', 'CustomBranding', 'AccountSetupActions',
    function ($scope, $stateParams, Auth, User, $location, Login, redirect, Logger, Notification, CustomBranding, AccountSetupActions) {
        var auth = Auth.get();
        if (auth) { // user is authenticated but tries to open login window
            $location.path('/history');
        }
        if ($stateParams.invalidToken) {
            Notification.error("invalid.token");
        }
        $scope.email = (auth || {}).email;
        $scope.pid = $stateParams.pid;

        $scope.loginMode = false;

        $scope.turnOnLoginMode = function() {
            $scope.loginMode = true;
        };

        $scope.login = function (user) {   /*{'user': {'email': user.email, 'password': user.password }}*/

            Login.login({'user': user},
                function (success) {
                    Auth.set({email: user.email, roles: success.roles, id: success.id, practice_id: success.practice_id});
                    user = User.get({id: success.id}, function(success){
                        CustomBranding.applyForUser(user);
                        // After login, evaluate post-login account setup actions (non-blocking).
                        AccountSetupActions.checkAndShow();
                    }, function(error) {
                        // Silently handle authentication errors as authInterceptor will handle the redirect
                        if (error.status !== 401 && error.status !== 403) {
                            Logger.log('Failed to load user details after login', error);
                        }
                    });
                    Auth.current_user = user;
                    $scope.email = user.email;
                    // Consume the saved destination one-shot: a later login without a
                    // fresh capture must not replay it.
                    var destination = redirect.path;
                    redirect.path = '/history';
                    $location.url(destination);
                },
                function (failure) {
                    // Do not log the raw failure object: it contains request config and $resource payload (including the typed password).
                    // Log a minimal summary instead (Logger also redacts sensitive fields defensively).
                    Logger.log('Login failed', {
                        status: failure && failure.status,
                        statusText: failure && failure.statusText,
                        code: failure && failure.data && failure.data.code,
                        errors: failure && failure.data && failure.data.errors
                    });
                    Auth.remove();
                    user.password = undefined;
                    const data = failure.data;
                    let message;
                    if (failure.status === 0) {
                        message = 'Upstream server connectivity error.  Please try again later';
                    } else if (failure.status === 429 || (data && data.code === 'too_many_requests')) {
                        // Handle rate limiting / too many login attempts
                        message = 'Too many login attempts. Please wait 1 minute before trying again.';
                    } else if (!!data && Array.isArray(data.errors) && !!data.errors.length) {
                        message = data.errors[0];
                    } else {
                        message = 'Unable to login with provided credentials';
                    }
                    Notification.error(message);
                    $scope.$broadcast('focusPassword');
                });
        };
    }]);

